import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CURRENT_USER,
  CURRENT_USER_SUCCESS,
  CURRENT_USER_FAILURE,
  EDIT_PROFILE,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  REGISTER_USER,
  REGISTER_SUCCESS,
  GET_INVITATION,
  GET_INVITATION_SUCCESS,
} from "./actionTypes";

export const loginUser = (payload) => {
  return {
    type: LOGIN_USER,
    payload,
  };
};

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const registerUser = (payload) => {
  return {
    type: REGISTER_USER,
    payload,
  };
};

export const registerSuccess = (user) => {
  return {
    type: REGISTER_SUCCESS,
    payload: user,
  };
};

export const logoutUser = () => {
  return {
    type: LOGOUT_USER,
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
  };
};

export const getInvitation = (payload) => {
  return {
    type: GET_INVITATION,
    payload,
  };
};

export const getInvitationSuccess = (payload) => {
  return {
    type: GET_INVITATION_SUCCESS,
    payload,
  };
};

export const getCurrentUser = () => {
  return {
    type: CURRENT_USER,
  };
};

export const getCurrentUserSuccess = (payload) => {
  return {
    type: CURRENT_USER_SUCCESS,
    payload,
  };
};

export const getCurrentUserFailure = (payload) => {
  return {
    type: CURRENT_USER_FAILURE,
    payload,
  };
};

export const editProfile = (payload) => {
  return {
    type: EDIT_PROFILE,
    payload,
  };
};

export const editProfileSuccess = (payload) => {
  return {
    type: EDIT_PROFILE_SUCCESS,
    payload,
  };
};

export const editProfileFailure = (payload) => {
  return {
    type: EDIT_PROFILE_FAILURE,
    payload,
  };
};

export const apiError = (error) => {
  console.log(error);
  return {
    type: API_ERROR,
    payload: error,
  };
};
